// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3KFTm","content":"ManualTimeModal_content__2s_-Z"};